import { DiagnosticType } from '../../Enum/DiagnosticType';
import { StatusEnum } from '../../Enum/StatusEnum';
import { CPTcode } from '../Shared/CPTCodeGroup';

import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface IDiagnosticStatus {
    CompletedDate: string;
    DiagnosticType: DiagnosticType;
    DiagnosticAssessmentStatus: StatusEnum;
    CreatedBy: CreatedBy;
    IsOncePerYear: boolean;
    CPTcode?: CPTcode;
}

export class DiagnosticStatus implements IDiagnosticStatus {
    CompletedDate: string;
    DiagnosticType: DiagnosticType;
    DiagnosticAssessmentStatus: StatusEnum;
    CreatedBy: CreatedBy;
    IsOncePerYear: boolean;
    CPTcode?: CPTcode;

    constructor() {
        this.DiagnosticType = DiagnosticType.None;
    }
}
